<template>
  <div class="box-bd clearfix">
    <div class="row">
     <div class="flashsale-countdown rainbow-item-4 span4">
        <img src="../../../assets/imgs/app1.jpg" alt="登录">
      </div> 
      <div class="span16 flashsale-list swiper-container swiper-no-swiping swiper-container-initialized swiper-container-horizontal">
        <ul class="swiper-wrapper" :style="{transform:' translateX('+ translateXX+'px)', transitionDuration: translateDur+'ms'}">
          <li class="swiper-slide rainbow-item-1 swiper-slide-active" style="width: 234px; margin-right: 14px;" v-for="i in 7" :key='i'>
			  <!-- <img  style="width: 234px;height: 507px;" :src="`../../../assets/imgs/app${i}.png`" /> -->
			<img   style="width: 234px;height: 507px;" :src="require(`../../../assets/imgs/app${i}.png`)" alt="" />
		  </li>
		  <!--  -->
        </ul>
      </div>
      <div class="swiper-controls">
        <span class="swiper-flashsale-prev" :class="translateXX===0 ? 'swiper-button-disabled' : ''" role="button" @click="prev">
          <i>&lt;</i>
        </span>
        <span class="swiper-flashsale-next" :class="translateXX==-992 ? 'swiper-button-disabled' : ''" role="button" @click="next">
          <i>&gt;</i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content',
  data() {
    return {
      translateXX: 0,
      translateDur: 0,
      // Daojishi: '',
      When_Hour: '',
      When_Minute: '',
      When_Second:'',
      timer: null,
      time: 0
    }
  },
  created(){
    this.timer = setInterval(() => {
      this.time++;
      if (this.time == 10) {
        this.Daojishi();
        this.time = 0;
      }
    }, 100);
  },
  mounted(){
    
  },
  methods:{
    prev(){
      if(this.translateXX<0){
        this.translateXX += 992
        this.translateDur = 1000
      }
    },
    next(){
      // this.translateXX -= 992
      // this.translateDur = 1000
      if(this.translateXX>-234*4){
        this.translateXX -= 992
        this.translateDur = 1000
      }
    },
    Daojishi(){
      var h = new Date;
      this.When_Hour =h.getHours()
      this.When_Minute=h.getMinutes()
      this.When_Second = h.getSeconds()
    }
  }
};
</script>

<style lang="less" scoped>
.row {
  margin-left: -14px;
}
.home-flashsale .rainbow-item-4 {
  border-top-color: #e53935;
}
.home-flashsale .flashsale-countdown {
  height: 300px;
  // padding-top: 39px;
  border-top-width: 1px;
  border-top-style: solid;
  background: #f1eded;
  text-align: center;
  .round{
    font-size: 21px;
    color: #ef3a3b;
    padding-top: 15px;
  }
  img{
    margin: 5px auto;
  }
  .desc{
    color: rgba(0,0,0,.54);
    font-size: 15px;
  }
  .countdown{
    width: 168px;
    margin: 28px auto 0;
    span{
      width: 46px;
      height: 46px;
      background: #605751;
      color: #fff;
      font-size: 24px;
      line-height: 46px;
      float: left;
    }
    i{
      width: 15px;
      float: left;
      height: 46px;
      line-height: 46px;
      color: #605751;
      font-size: 28px;
      font-style: normal;
    }
  }
}

.home-flashsale .rainbow-item-4 {
  border-top-color: #e53935;
}
.home-flashsale .flashsale-countdown {
  height: 400px;
  // padding-top: 39px;
  border-top-width: 1px;
  border-top-style: solid;
  background: #f1eded;
  text-align: center;
}
.span4 {
  width: 234px;
}



// 右边的轮播商品
.home-flashsale .flashsale-list {
  float: left;
  .swiper-wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform,-webkit-transform;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
  }
  li{
    width: 234px;
    margin-right: 14px;
    border-top-width: 1px;
    border-top-style: solid;
    text-align: center;
    background: #fff;
    -webkit-transition: all .6s;
    transition: all .6s;
    position: relative;
    list-style: none;
    a{
      display: block;
      height: 400px;
      // padding-top: 39px;
      position: relative;
    }
    a::after{
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      background: rgba(0,0,0,.02);
    }
    .thumb{
      display: block;
      width: 160px;
      margin: 0 auto 22px;
      img{
        width: 160px;
        height: 160px;
      }
    }
    .title{
      margin: 0 20px 3px;
      font-size: 14px;
      font-weight: 400;
      text-overflow: ellipsis;
      color: #212121;
      overflow: hidden;
      white-space: nowrap;
    }
    .desc{
      height: 18px;
      margin: 0 20px 12px;
      font-size: 12px;
      text-overflow: ellipsis;
      color: #b0b0b0;
      overflow: hidden;
      white-space: nowrap;
    }
    .price{
      margin: 0;
      color: #ff6709;
      del{
       color: #b0b0b0;; 
      }
    }
  }
  
}
.span16 {
  width: 978px;
}
.swiper-container {
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}


// 左右滚动控制按钮
.home-flashsale .swiper-controls {
  position: absolute;
  right: 0;
  top: 24px;
  .swiper-button-disabled {
    color: #e0e0e0 !important;
    cursor: default !important;
  }
  .swiper-flashsale-prev,.swiper-flashsale-next{
    display: inline-block;
    width: 24px;
    height: 16px;
    padding: 3px 5px;
    margin-left: -1px;
    border: 1px solid #e0e0e0;
    font-size: 16px;
    line-height: 16px;
    -webkit-transition: color .5s;
    transition: color .5s;
    color: #b0b0b0;
    text-align: center;
    cursor: pointer;
    user-select:none;
  }
  .swiper-flashsale-prev :hover,
  .swiper-flashsale-next :hover{
    color:#ff6700 ;
  }
}
.bgimg{
	height: 500px;
	width: 234px;
	margin-left: 10px;
	background-image: url(../../../assets/imgs/app2.png);
}
</style>
